import { useState, useEffect } from 'react';
import { Button } from '@mui/material';
import SectionWrapper from './Components/SectionWrapper';
import showToast from '../../../Helpers/toast';
import useApi from '../../../Hooks/useApi';

const SDGUploadSection = ({ city, year, onSubmitSuccess }) => {
 
    const [file, setFile] = useState(null);
    const [preview, setPreview] = useState(null);
    const [loading, setLoading] = useState(false);
    const { request } = useApi(); 

    const handleFileChange = (e) => {
        if (e.target.files && e.target.files[0]) {
            const selectedFile = e.target.files[0];
            setFile(selectedFile);
            
            const reader = new FileReader();
            reader.onloadend = () => {
                setPreview(reader.result);
            };
            reader.readAsDataURL(selectedFile);
        }
    };

    const handleClearFile = () => {
        setFile(null);
        setPreview(null);
        const fileInput = document.getElementById('sdg-upload-file');
        if (fileInput) fileInput.value = '';
    };

    const handleSubmit = async () => {
        if (!file || !city || !year) {
            showToast({ message: 'Please select a file and ensure city/year are selected.', type: 'error' });
            return;
        }

        setLoading(true);
        
        const formData = new FormData();
        formData.append('image', file);

        try {
            const response = await request(
                "PUT",
                `/v1/shit-flow-diagram/locations/${city}/${year}/upload`,
                {
                    data: formData,
                    headers: {
                        'Content-Type': undefined 
                    }
                },
                "survey_service"
            );
            
            showToast({ message: 'Shit-flow Diagram uploaded successfully!', type: 'success' });
            handleClearFile();
            
            if (onSubmitSuccess) onSubmitSuccess();
        } catch (error) {
            const errorMessage = error?.response?.data?.message || error?.message || 'Upload failed';
            showToast({ message: errorMessage, type: 'error' });
            console.error('Upload error:', error);
        } finally {
            setLoading(false);
        }
    };

    // Cleanup preview URL on unmount
    useEffect(() => {
        return () => {
            if (preview) {
                URL.revokeObjectURL(preview);
            }
        };
    }, [preview]);

    return (
        <SectionWrapper title="Upload Shit Flow Diagram (SFD)">
            <div className="p-4 border border-dashed border-gray-300 rounded-lg bg-gray-50">
                
                {/* File Selection Area */}
                {!preview && (
                    <div className="text-center">
                        <input
                            accept="image/*,.png,.jpg,.jpeg" 
                            style={{ display: 'none' }}
                            id="sdg-upload-file"
                            type="file"
                            onChange={handleFileChange}
                        />
                        <label htmlFor="sdg-upload-file">
                            <Button variant="outlined" component="span">
                                Choose File
                            </Button>
                        </label>
                        <p className="mt-2 text-xs text-gray-500">
                            Supported formats: PNG, JPG, JPEG
                        </p>
                    </div>
                )}

                {/* Preview Area */}
                {preview && (
                    <div className="space-y-4">
                        <div className="flex items-center justify-between">
                            <div className="text-sm text-gray-700">
                                <strong>Selected:</strong> {file.name}
                            </div>
                            <Button 
                                variant="outlined" 
                                color="secondary" 
                                size="small"
                                onClick={handleClearFile}
                            >
                                Change File
                            </Button>
                        </div>

                        {/* Image Preview */}
                        <div className="border-2 border-gray-300 rounded-lg overflow-hidden bg-white p-2">
                            <img 
                                src={preview} 
                                alt="SFD Preview" 
                                className="w-full h-auto max-h-96 object-contain"
                            />
                        </div>

                  

       
                        <div className="flex gap-2 justify-center">
                            <Button 
                                variant="contained" 
                                color="primary" 
                                onClick={handleSubmit}
                                disabled={loading}
                                fullWidth
                            >
                                {loading ? 'Uploading...' : 'Upload Diagram'}
                            </Button>
                        </div>
                    </div>
                )}
            </div>
        </SectionWrapper>
    );
};

export default SDGUploadSection;